import api from '../../../utils/api';

export const boardService = {
  listThreads: async (clubId, { q = '', tags = [], limit = 20, offset = 0 } = {}) => {
    const params = new URLSearchParams();
    if (q) params.set('q', q);
    (tags || []).forEach((t) => {
      if (t) params.append('tags', t);
    });
    params.set('limit', String(limit));
    params.set('offset', String(offset));
    const query = params.toString();
    const url = query
      ? `/clubs/${clubId}/board/threads/?${query}`
      : `/clubs/${clubId}/board/threads/`;
    const res = await api.get(url);
    return res.data;
  },

  createThread: async (clubId, { title, tags = [], first_post }) => {
    const res = await api.post(`/clubs/${clubId}/board/threads/`, { title, tags, first_post });
    return res.data;
  },

  /** President announcement: server applies announcement tag + 3-day pin. */
  createClubAnnouncement: async (clubId, { title, body_html, images = [] }) => {
    const res = await api.post(`/clubs/${clubId}/board/threads/`, {
      title,
      tags: ['announcement'],
      first_post: { body_html, images },
    });
    return res.data;
  },

  getThread: async (clubId, threadId, { limit = 20, offset = 0 } = {}) => {
    const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
    const res = await api.get(`/clubs/${clubId}/board/threads/${threadId}/?${params.toString()}`);
    return res.data;
  },

  createPost: async (clubId, threadId, { body_html, images = [] }) => {
    const res = await api.post(`/clubs/${clubId}/board/threads/${threadId}/posts/`, { body_html, images });
    return res.data;
  },

  editPost: async (clubId, threadId, postId, { body_html, images }) => {
    const res = await api.patch(`/clubs/${clubId}/board/threads/${threadId}/posts/${postId}/`, { body_html, images });
    return res.data;
  },

  deletePost: async (clubId, threadId, postId, { delete_reason } = {}) => {
    const config = delete_reason ? { data: { delete_reason } } : undefined;
    const res = await api.delete(`/clubs/${clubId}/board/threads/${threadId}/posts/${postId}/`, config);
    return res.data;
  },

  editThread: async (clubId, threadId, { title, tags }) => {
    const res = await api.patch(`/clubs/${clubId}/board/threads/${threadId}/`, { title, tags });
    return res.data;
  },

  deleteThread: async (clubId, threadId, { delete_reason } = {}) => {
    const config = delete_reason ? { data: { delete_reason } } : undefined;
    const res = await api.delete(`/clubs/${clubId}/board/threads/${threadId}/`, config);
    return res.data;
  },

  getUnreadSummary: async () => {
    const res = await api.get('/clubs/board/unread/');
    return res.data;
  },

  markBoardRead: async (clubId) => {
    const res = await api.post(`/clubs/${clubId}/board/mark-read/`, {});
    return res.data;
  },

  initBoardImageUpload: async ({ clubId, threadId, filename, contentType }) => {
    const res = await api.post('/assets/init/', {
      filename: filename || 'image.jpg',
      content_type: contentType || 'image/jpeg',
      scope: 'board-image',
      club_id: clubId,
      thread_id: threadId || 'new',
    });
    return res.data;
  },
};
